import ActivityFeed from '@app/components/ActivityFeed'
import FeedItemEditor from '@app/components/FeedItemEditor'
import { FeedItemSourceType } from '@app/models/enums'
import * as React from 'react'
import { DevelopmentSiteViewPageProps } from './DevelopmentSiteViewPage'

export default class DevelopmentSiteActivity extends React.PureComponent<
  DevelopmentSiteViewPageProps
> {
  public render() {
    return (
      <div key={this.props.site.id}>
        <div className='mx-2'>
          <FeedItemEditor
            contextId={this.props.site.id}
            contextType={FeedItemSourceType.DevelopmentSite}
          />
        </div>
        <ActivityFeed contextId={this.props.site.id} />
      </div>
    )
  }
}
